import React from "react";
import { Box } from "@mui/material";

import { ThumbUpOffAlt, ThumbUp, ThumbDown, ThumbDownOffAlt } from "@mui/icons-material";

export const CommunityReviewRecommendationSection = ({ isRecommended, onClick }) => {
  return (
    <Box sx={{
      display: "flex",
      gap: 2
    }}>
      <Box
        onClick={() => onClick(!isRecommended)}
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          justifyContent: "center",
          width: 56,
          height: 56,
          borderRadius: "50%",
          backgroundColor: isRecommended ? "black" : "gray",
          color: "white",
          cursor: isRecommended ? "auto" : "pointer"
        }}
      >
        {isRecommended ? <ThumbUp /> : <ThumbUpOffAlt />}
      </Box>
      <Box
        onClick={() => onClick(!isRecommended)}
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          justifyContent: "center",
          width: 56,
          height: 56,
          borderRadius: "50%",
          backgroundColor: !isRecommended ? "black" : "gray",
          color: "white",
          cursor: !isRecommended ? "auto" : "pointer"
        }}
      >
        {isRecommended ? <ThumbDownOffAlt /> : <ThumbDown />}
      </Box>
    </Box>
  );
};
